const article_icon_heading = () => {
  const selector = 'article_icon_heading';
  const instances = document.querySelectorAll(`.${selector}`);
  const debug = false;

  const getHeading = item => {
    const el = document.createElement('h4');
    const span = document.createElement('span');
    span.innerText = item.getAttribute('data-title');
    el.appendChild(span);
    return el;
  };

  const getIcon = item => {
    if (item.getAttribute('data-icon') !== '') {
      const el = document.createElement('img');
      el.classList = 'article_icon_heading-icon';
      el.src = item.getAttribute('data-icon');
      return el;
    }
  };

  // Loop through all items of data and
  // render it to the page
  const renderData = instance => {
    const dataItems = Array.from(instance.querySelectorAll('data'));

    dataItems.forEach(item => {
      // Heading
      const heading = getHeading(item);
      instance.appendChild(heading);

      // Icon
      const icon = getIcon(item);
      heading.insertBefore(icon, heading.querySelector('span'));

      // Content
      const markup = Array.from(item.children);
      markup.forEach(el => {
        instance.appendChild(el);
      });

      // Remove data element
      if (!debug) {
        item.remove();
      }
    });
  };

  // Loop through all components and output data
  instances.forEach(instance => renderData(instance));
};
article_icon_heading();
